<template>
    <Paper :header="$t('companyDetail.videos.header')" class="videos-root">
        <div v-if="!items" style="padding-bottom: 20px">
            <ImageTextSkeleton />
        </div>
        <Carousel
            v-else
            :component="getComponent()"
            :items="items"
            onlyShowSingleItem
            hideArrows
            @item-click="onVideoClick"
            :noResourcesImage="noVideoImage"
            :noResourcesMessage="$t('companyDetail.videos.noVideos')"
        />
    </Paper>
</template>

<script>
import ExtendedVideoDialog from './ExtendedVideo.Dialog';
import VideosCarouselItem from '~/components/miscellaneous/Videos.CarouselItem';
import ImageTextSkeleton from '~/components/skeletons/ImageTextSkeleton';

// Assets
import VideoSvg from '~/assets/img/video.svg';

// Utils
import DialogService from '~/services/DialogService';

export default {
    name: 'Videos',

    components: { ImageTextSkeleton },
    props: {
        items: Array,
        orgId: [Number, String],
    },
    data: () => ({
        noVideoImage: VideoSvg,
    }),
    methods: {
        getComponent() {
            return VideosCarouselItem;
        },
        onVideoClick(item) {
            DialogService.openVideoDialog(
                {
                    ...item,
                    orgProfileId: this.orgId,
                },
                ExtendedVideoDialog
            );
        },
    },
};
</script>

<style scoped>
.videos-root {
    overflow: hidden;
    max-height: 100%;
    max-width: 100%;
}

.videos {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-auto-flow: column;
    grid-gap: 25px;
}

.video-item {
    cursor: pointer;
}

.video-item:hover img {
    transform: scale(1.02);
}
</style>
